import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export function CTASection() {
	return (
		<section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-blue-600 to-purple-600">
			<div className="mx-auto max-w-4xl text-center">
				<div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
					<Button
						size="lg"
						className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200 shadow-lg"
						asChild
					>
						<Link href="/signup" className="flex items-center">
							Start Free Trial
							<ArrowRight className="ml-2 w-5 h-5" />
						</Link>
					</Button>
					<Button
						size="lg"
						variant="outline"
						className="border-white/30 text-white hover:bg-white/10 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200"
						asChild
					>
						<Link href="/demo">Book a Demo</Link>
					</Button>
				</div>

				<div className="mt-8 flex items-center justify-center space-x-8 text-blue-100 text-sm">
					<div className="flex items-center space-x-2">
						<span className="w-2 h-2 bg-green-400 rounded-full"></span>
						<span>14-day free trial</span>
					</div>
					<div className="flex items-center space-x-2">
						<span className="w-2 h-2 bg-green-400 rounded-full"></span>
						<span>No credit card required</span>
					</div>
					<div className="flex items-center space-x-2">
						<span className="w-2 h-2 bg-green-400 rounded-full"></span>
						<span>Setup in 5 minutes</span>
					</div>
				</div>
			</div>
		</section>
	);
}
